module.exports = __webpack_public_path__ + "static/media/screen-2.378ac2d5.svg";